import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import { cmes, formatoMonto, formatMoneda } from "../../util/varios";
import { Dimmer } from "../spinner";
import { Mensaje } from "../mensajes";
import { ToastsGeneral } from "../toasts";
import ModalActuDolar from "./modalActualizarDolar";

const headCells = [
  {
    id: "codigo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "AÑO",
    textAlign: "center",
  },
  {
    id: "nombre",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "MES",
    textAlign: "center",
  },
  {
    id: "rif",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "FECHA",
    textAlign: "center",
  },
  {
    id: "nrolicencia",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "VALOR",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: " OPCIONES",
    textAlign: "center",
  },
];

function TablaDolarBcv() {
  moment.locale("es");

  const [mostrar, setMostrar] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [anioActu, setAnioActu] = useState(localStorage.getItem("anioactu"));
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [permiso, setPermiso] = useState();
  const [petro, setPetro] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [records, setRecords] = useState([]);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accuc = JSON.parse(localStorage.getItem("accuc"));

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.anio.includes(target.value) ||
              cmes(parseInt(x.mes))
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.valor.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarDolar = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/valordolarbcv`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setRecords(response.data);

            setActivate(false);
          } else {
            setRecords([]);
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelectRegistro = (anio, mes, valor) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/valordolarbcv/vervalor?anio=${anio}&mes=${mes}&valor=${valor}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.anio >= 0) {
            setPetro(response.data);

            setActivate(false);
            setMostrar(true);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "error al cargar usuario",
              icono: "informacion",
            });
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const operaciones = (anio, mes, valor, op) => (e) => {
    e.preventDefault();
    setOperacion(op);

    if (op === 4) {
      if (accuc.substring(0, 1) !== "0") {
        SelectRegistro(anio, mes, valor);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 1) {
      if (accuc.substring(1, 2) !== "0") {
        setMostrar(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (accuc.substring(2, 3) !== "0") {
        SelectRegistro(anio, mes, valor);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (accuc.substring(3, 4) !== "0") {
        SelectRegistro(anio, mes, valor);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    }
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  const cerrarModal = () => {
    setMostrar(false);
    setPetro("");
  };

  useEffect(() => {
    seleccionarDolar();
  }, []);

  return (
    <div className="h-100 w-100 p-0 m-0">
      <div className="container">
        <div className="content">
          <div className="card px-3 py-2">
            <div className="col-md-12 row m-0 py-1">
              <div className="col-md-2">
                <input
                  type="text"
                  className="form-control form-control-sm rounded-pill"
                  onChange={handleSearch}
                  placeholder="Buscar"
                />
              </div>

              <div className="col-md-1 ml-auto">
                <button
                  onClick={operaciones("", "", "", 1)}
                  className={
                    accuc.substring(0, 1) === "0"
                      ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                      : "btn btn-sm mx-1 btn-primary rounded-circle"
                  }
                >
                  <i className="fas fa-plus"></i>{" "}
                </button>
              </div>
            </div>
            <div className="col-md-12">
              <TblContainer>
                <TblHead />

                <TableBody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <TableRow key={index} style={{ padding: "0" }}>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center" }}
                        >
                          {item.anio}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "start" }}
                        >
                          {cmes(parseInt(item.mes))}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center" }}
                        >
                          {moment(item.fechaaplic).format("L")}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "end", width: "200px" }}
                        >
                          {formatMoneda(
                            item.valor.replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center", width: "200px" }}
                        >
                          <button
                            onClick={operaciones(
                              item.anio,
                              item.mes,
                              item.valor,
                              4
                            )}
                            className={
                              accuc.substring(0, 1) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-info rounded-circle"
                            }
                          >
                            <i className="fas fa-eye"></i>{" "}
                          </button>
                          <button
                            onClick={operaciones(
                              item.anio,
                              item.mes,
                              item.valor,
                              2
                            )}
                            className={
                              accuc.substring(2, 3) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-warning rounded-circle"
                            }
                          >
                            <i className="fa fa-edit"></i>{" "}
                          </button>
                          <button
                            onClick={operaciones(
                              item.anio,
                              item.mes,
                              item.valor,
                              3
                            )}
                            className={
                              accuc.substring(3, 4) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-danger rounded-circle"
                            }
                          >
                            <i className="fa fa-trash"></i>{" "}
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </div>
          </div>
        </div>
      </div>
      <ToastsGeneral
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
      <ModalActuDolar
        show={mostrar}
        onHideCancela={cerrarModal}
        operacion={operacion}
        petro={petro}
        onHideRenderizar={seleccionarDolar}
      />
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </div>
  );
}

export default TablaDolarBcv;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/tablaDolarBcv.js